import { defineComponent as _defineComponent } from 'vue'
import { ModalHelper } from '@/helpers/modal-helper';
import ReelModal from '@/components/experiments/ReelsExp/components/ReelModal.vue';
import { MovieOrShow } from '@/@types/graphql-types';
import { ref } from 'vue';
import HLSPlayer from '@/components/experiments/ReelsExp/components/HLSPlayer.vue';
import { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';
import { getClipFromMovieOrShow } from '@/components/experiments/ReelsExp/components/query';

import ReelsExp from '../index';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelMobileOverlay',
  props: {
    queryVariables: null,
    autoplay: { type: Boolean },
    title: null
  },
  setup(__props: any) {

const props = __props as {
	queryVariables: GetPopularTitlesQueryVariables;
	autoplay: boolean;
	title: MovieOrShow;
};

const player = ref<typeof HLSPlayer>(null as any);



const clipUrl = getClipFromMovieOrShow(props.title);

function handleClick() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'video_player_open',
		property: 'shorts_popular',
	});
	openModal();
}

function openModal() {
	ReelsExp.trackEvent({
		action: 'impression',
		property: 'shorts_popular',
	});
	ModalHelper.openModal(
		ReelModal,
		{ queryVariables: props.queryVariables, title: props.title.id },
		{ cssClass: 'reel-modal' }
	);
}

// const expanded = ref(false);

// const emit = defineEmits(['finishPlayback']);

// function pause() {
// 	player.value.pause();
// 	expanded.value = false;
// }

// function finishPlayback() {
// 	pause();
// 	emit('finishPlayback');
// }

// defineExpose({
// 	pause: pause,
// 	play: () => {
// 		expanded.value = true;
// 		setTimeout(() => {
// 			player.value.reset();
// 			player.value.play();
// 		}, 1);
// 	},
// });

return { __sfc: true,player, props, clipUrl, handleClick, openModal, HLSPlayer }
}

})